function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M13.115,14.531V9.766h1.538V3.859L13.331,2.515l-.816.829.985,1V6.25H12.346V5.273a2.157,2.157,0,0,0-.882-1.744,2.158,2.158,0,0,0,.5-1.381,2.116,2.116,0,1,0-4.231,0,2.158,2.158,0,0,0,.5,1.381,2.157,2.157,0,0,0-.882,1.744V6.25H6.192V4.344l.985-1-.816-.829L5.038,3.859V9.766H6.577v4.766Zm-1.154-1.172H7.731V9.766h4.231ZM9.846,1.172a.977.977,0,1,1-.962.977A.97.97,0,0,1,9.846,1.172ZM8.5,5.273A.97.97,0,0,1,9.462,4.3h.769a.97.97,0,0,1,.962.977V6.25H8.5ZM6.192,7.422H13.5V8.594H6.192Z",
  transform: "translate(-2.346)",
  fill: "#10151b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M9.846,15.7a2.149,2.149,0,1,0,2.115,2.148A2.134,2.134,0,0,0,9.846,15.7Zm0,3.125a.977.977,0,1,1,.962-.977A.97.97,0,0,1,9.846,18.828Z",
  transform: "translate(-2.346)",
  fill: "#10151b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M4.462,15.7a2.149,2.149,0,1,0,2.115,2.148A2.134,2.134,0,0,0,4.462,15.7Zm0,3.125a.977.977,0,1,1,.962-.977A.97.97,0,0,1,4.462,18.828Z",
  transform: "translate(-2.346)",
  fill: "#10151b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M15.231,15.7a2.149,2.149,0,1,0,2.115,2.148A2.134,2.134,0,0,0,15.231,15.7Zm0,3.125a.977.977,0,1,1,.962-.977A.97.97,0,0,1,15.231,18.828Z",
  transform: "translate(-2.346)",
  fill: "#10151b"
}));

var SvgSeminar = function SvgSeminar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conference",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeminar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/seminar.ced64a4c.svg";
export { ForwardRef as ReactComponent };